import {Autocomplete, Box, TextField} from "@mui/material";
import React, {useState} from "react";
import {MultiSearchProps} from "../../components/SearchBox";
import {Tables} from "../../apitypes";
import AvatarImage from "../storage/AvatarImage";
import {useGetPartnerQuery} from "./partner_api";


export default ({onChange, value, label}: MultiSearchProps<Tables<"partner">>) => {

    const [filter, setFilter] = useState("");
    const {data} = useGetPartnerQuery({
        filter: filter,
        pageSize: 30,
        page: 0,
        sort: [{col: "Name", dir: "desc"}]
    })

    return <Autocomplete
        id={"partner"}
        multiple
        options={data?.result || []}
        autoHighlight
        sx={{minWidth: "200px"}}
        value={value}
        filterOptions={x => x}

        onChange={(e, v: Tables<"partner">[]) => onChange(v)}
        getOptionLabel={(option: Tables<"partner">) => {
            return option.Name;
        }}
        onInputChange={(e, v) => setFilter(v)}
        renderOption={(props, option: Tables<"partner">) => {
            const {key, ...rest} = props
            return <Box component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} key={key} {...rest}>
                <AvatarImage image_url={option.image_url} bucket={"partners"}/> {option.Code} {option.Name}
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}

                label={label || "Partner"}
                variant={"standard"}
            />
        )}
    />

}
